'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _list = require('./list.attribute');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (attributes) {
  return (0, _list2.default)(attributes).map(function (attr) {
    return attr.reinit(attr.value(), null, attributes);
  });
}; // List